import React from 'react';

import { TextSmall } from 'components/chroma/extended';
import { Text } from 'components/chroma';
import { tAndCInsDiscountUrl } from 'scenes/common/helpers/contacts';
import { toPercentage } from 'scenes/common/helpers/percentage';
import {
  DEFAULT_ONLINE_CAMPAIGN,
  insuranceDiscount,
} from 'scenes/common/helpers/insuranceInfo';
import { InsuranceName } from 'scenes/common/types';

export const BuildingDiscount = () => (
  <Text style={{ minHeight: 100 }}>
    Get a {toPercentage(DEFAULT_ONLINE_CAMPAIGN.discount)} online discount with
    building cover (T&#38;Cs apply, subject to minimum premiums).&#126;
  </Text>
);

export const ContentsDiscount = () => (
  <Text style={{ minHeight: 100 }}>
    Get a {toPercentage(DEFAULT_ONLINE_CAMPAIGN.discount)} online discount with
    contents cover (T&#38;Cs apply, subject to minimum premiums).&#126;
  </Text>
);

export const CommonDiscountRelated = () => (
  <TextSmall>
    &#126;Minimum premiums may apply. This online discount offer may be
    withdrawn at any time. Applies to new policies only. For full terms and
    conditions, see{' '}
    <a href={tAndCInsDiscountUrl()} target="_blank" rel="noopener noreferrer">
      here
    </a>
    .
  </TextSmall>
);

export const BuildingAndContentsDiscount = () => (
  <Text style={{ minHeight: 100 }}>
    Get a {toPercentage(insuranceDiscount(InsuranceName.Home))} discount for
    combining building and contents when buying online. Made up of the{' '}
    {toPercentage(DEFAULT_ONLINE_CAMPAIGN.discount)} online discount and a{' '}
    {toPercentage(DEFAULT_ONLINE_CAMPAIGN.discount)} discount for combining your
    Coles Home Building and Contents Insurance (T&#38;Cs apply, subject to
    minimum premiums).&#42;
  </Text>
);

export const BuildingAndContentsDiscountRelated = () => (
  <TextSmall>
    &#42;The 30% discount is made up of the{' '}
    {toPercentage(DEFAULT_ONLINE_CAMPAIGN.discount)} online discount and a{' '}
    {toPercentage(DEFAULT_ONLINE_CAMPAIGN.discount)} combined policy discount.
    Minimum premiums may apply. This discount offer may be withdrawn at any
    time. Applies to new policies only. For full terms and conditions, see{' '}
    <a href={tAndCInsDiscountUrl()} target="_blank" rel="noopener noreferrer">
      here
    </a>
    .
  </TextSmall>
);
